import useLang from "../i18n/LanguageContext";
import "./Footer.css";

const SOCIALS = [
  { label: "LinkedIn", short: "in", href: "https://www.linkedin.com/in/mert-kerimi-853984218/" },
  { label: "GitHub", short: "gh", href: "https://github.com/mertkerimi" },
  { label: "Instagram", short: "ig", href: "https://www.instagram.com/mertkerimi/" },
];

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__inner">
        {/* The space bar */}
        <a href="#top" className="footer__bar" data-critter="top">
          <span>
            © {year} {t.footer.copy}
          </span>
          <span className="footer__top">{t.footer.top}</span>
        </a>
        <div className="footer__socials" data-critter="socials">
          {SOCIALS.map((s) => (
            <a key={s.short} href={s.href} aria-label={s.label} className="footer__social">
              {s.short}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
